import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENV || "lovable_or_local",
  sendDefaultPii: true,
});

createRoot(document.getElementById("root")!).render(<App />);
